import { MouseEvent, useContext, useRef } from "react"
import { TextureTestWizardContext, WizardSectionId } from "./TextureTestWizardContextProvider"
import { motion } from "framer-motion"
import "./WizardOutcome.scss"
import { WizardStepAnswerResult } from "./WizardStepDefinitions"
import { fadeIn } from "./WizardAnimation"
import { WizardSection } from "./WizardSection"

export const WizardOutcome = () => {
  const { section, reset, outcome } = useContext(TextureTestWizardContext)

  return (
    <WizardSection visible={section === WizardSectionId.Outcome} className="WizardOutcome">
      <div key={WizardSectionId.Outcome}>
        {outcome === WizardStepAnswerResult.TestFail && <WizStepFail />}
        {outcome === WizardStepAnswerResult.MissingTools && <WizStepFailTools />}
        {outcome === WizardStepAnswerResult.TestSuccess && <WizStepSuccess />}
      </div>
      <button id="btn-iddsi-start-again" onClick={reset}>
        Start Again
      </button>
    </WizardSection>
  )
}

const WizStepFail = () => {
  const { testTextureLabel } = useContext(TextureTestWizardContext)

  return (
    <p>
      This food does not meet the requirements for <strong>{testTextureLabel}</strong>.
    </p>
  )
}

const WizStepFailTools = () => {
  const { testTextureLabel } = useContext(TextureTestWizardContext)

  return (
    <p>
      You don't have the required tools to complete the test for <strong>{testTextureLabel}</strong>.
    </p>
  )
}

export const WizStepSuccess = () => {
  const { testTextureLabel, foodName, setFoodName, userEmail, setUserEmail, sendEmail, emailStatus } =
    useContext(TextureTestWizardContext)
  const formRef = useRef<HTMLFormElement>(null)

  const handleSendEmail = async (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()

    if (formRef.current?.reportValidity()) {
      await sendEmail()
    }
  }

  return (
    <div className="WizStepSuccess">
      <p>
        This food meets the requirements for <strong>{testTextureLabel}</strong>.
      </p>
      <div className="email-form">
        <h2>Email the test outcome:</h2>
        <motion.form ref={formRef}>
          <div className="field">
            <label htmlFor="food">Food name</label>
            <input
              name="food"
              id="food"
              type="text"
              value={foodName}
              required={true}
              onChange={e => setFoodName(e.target.value)}
              disabled={emailStatus !== "unsent"}
            />
          </div>
          <div className="field">
            <label htmlFor="email">Email</label>
            <input
              name="email"
              id="email"
              type="email"
              value={userEmail}
              required={true}
              onChange={e => setUserEmail(e.target.value)}
              disabled={emailStatus !== "unsent"}
            />
          </div>
          {(emailStatus === "unsent" || emailStatus === "sending") && (
            <div className="field">
              <motion.button id="btn-iddsi-send" onClick={handleSendEmail} disabled={emailStatus !== "unsent"}>
                Send
              </motion.button>
            </div>
          )}
          {emailStatus === "failed" && (
            <motion.div {...fadeIn()} className="email-fail">
              There was an error while trying to send an email. Please try again later
            </motion.div>
          )}
          {emailStatus === "succeeded" && (
            <motion.div {...fadeIn()} className="email-success">
              Email successfully sent!
            </motion.div>
          )}
        </motion.form>
      </div>
    </div>
  )
}
